import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GlobalContext } from "../GlobalContext";

export default function CreateTeam() {
  const navigate = useNavigate();
  const { cid } = useParams();

  const { alert, setLoading } = useContext(GlobalContext);

  const [allSports, setAllSports] = useState([]);
  const [hasMembers, setHasMembers] = useState(true);
  const [competitiveSports, setCompetitiveSports] = useState(0);
  const [nonCompetitiveSports, setNonCompetitiveSports] = useState(0);

  useEffect(() => {
    setLoading(true);
    (async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/team/sports/${cid}`, {
        method: "GET",
        headers: {
          Authorization: localStorage.getItem("auth"),
        },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        const { sports, hasMembers } = data;
        setHasMembers(hasMembers);
        setAllSports(sports);
        setCompetitiveSports(sports[0][1].reduce((count, sport) => count + sport.hasTeam, 0));
        setNonCompetitiveSports(sports[1][1].reduce((count, sport) => count + sport.hasTeam, 0));
      } else {
        alert({ type: "warning", title: "Warning !", text: error });
      }
    })()
      .catch((error) => alert({ type: "danger", title: "Error !", text: error.message }))
      .finally(() => setLoading(false));
  }, [alert, cid, setLoading]);

  const createTeam = async (sid) => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/team`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("auth"),
        },
        body: JSON.stringify({ cid, sid }),
      });
      const { data, error } = await res.json();
      if (res.ok) {
        navigate(`/team-member/${cid}/${sid}`);
        alert({ type: "success", title: "Success !", text: data });
      } else {
        alert({ type: "warning", title: "Warning !", text: error });
      }
    } catch (error) {
      alert({ type: "danger", title: "Error !", text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const deleteTeam = async (sid, ix) => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/team/${cid}/${sid}`, {
        method: "DELETE",
        headers: {
          Authorization: localStorage.getItem("auth"),
        },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        setAllSports((allS) => {
          allS[ix][1] = allS[ix][1].map((sp) => (sp._id === sid ? { ...sp, hasTeam: false } : sp));
          return [...allS];
        });
        if (ix) setNonCompetitiveSports((c) => c - 1);
        else setCompetitiveSports((c) => c - 1);
        alert({ type: "success", title: "Success !", text: data });
      } else {
        alert({ type: "warning", title: "Warning !", text: error });
      }
    } catch (error) {
      alert({ type: "danger", title: "Error !", text: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-body">
      <div className="container-xl d-flex flex-column justify-content-center">
        <div className="card">
          <div className="card-header flex-column align-center">
            <h2 className="h2">Create Team</h2>
            <p>Maximum 3 Team Sports & Maximum 5 Individual Sports can be taken up in one club</p>
          </div>
          <div className="card-body">
            <div className="row">
              {allSports.map(([heading, sports], index) => (
                <div key={heading} className="col-lg-6">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">
                        <strong>{heading}</strong>
                      </h3>
                    </div>
                    <div className="list-group list-group-flush">
                      {sports.map((sp) => (
                        <div key={sp._id} className="list-group-item">
                          <div className="row align-items-center">
                            <div className="col text-truncate">{sp.name}</div>
                            <div className="col-auto">
                              {sp.hasTeam ? (
                                <>
                                  {sp.isSubmitted ? (
                                    <span className="badge badge-outline text-azure">submitted</span>
                                  ) : (
                                    <span className="badge badge-outline text-orange">pending</span>
                                  )}
                                  <button onClick={() => deleteTeam(sp._id, index)} className="btn btn-danger mx-1">
                                    Delete
                                  </button>
                                  <button onClick={() => navigate(`/team-member/${cid}/${sp._id}`)} className="btn btn-primary">
                                    Modify
                                  </button>
                                </>
                              ) : (
                                <button
                                  onClick={() => createTeam(sp._id)}
                                  className="btn btn-success mx-1"
                                  disabled={(index === 0 && competitiveSports >= 3) || (index === 1 && nonCompetitiveSports >= 5)}>
                                  Create Team
                                </button>
                              )}
                              {/* {sp.hasTeam && <button className="btn btn-danger mx-1">Delete Team</button>}
                              <Link
                                to={`/team-member/${cid}/${sp._id}`}
                                className="btn btn-primary">
                                Add Members
                              </Link> */}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="card-footer text-center">
            <button
              onClick={() => navigate(`/club-overview/${cid}`)}
              className="btn btn-success mx-1"
              disabled={
                hasMembers ||
                competitiveSports + nonCompetitiveSports < 1 ||
                allSports.some((spcat) => spcat[1].some((sp) => !sp.isSubmitted && sp.hasTeam))
              }>
              Club Submission
            </button>
          </div>
          <ul className="card-footer">
            <li>Please submit all the Teams which are in pending status or delete the same.</li>
            <li>Once all teams are submitted then only you can submit the club.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
